import React from 'react';
import './App.css';

const DMCAPage = () => {
  return (
    <div className='policy'>
      <h1>DMCA Copyright Policy</h1>
      <p><em>Last updated: 2026-05-26</em></p>

      <p>7HillsStudio LLC ("mChatAI") respects the intellectual property rights of others
      and expects users of our service to do the same. This page explains how copyright owners
      can notify us of allegedly infringing content distributed through mchatai.com or any of
      our applications, and how users whose content has been removed can submit a counter-notice
      under the Digital Millennium Copyright Act of 1998 ("DMCA"), 17 U.S.C. § 512.</p>

      <h2>Designated Copyright Agent</h2>
      <p>To submit a DMCA notice or counter-notice, contact our designated agent:</p>
      <ul>
        <li><strong>Designated Agent:</strong> Lawrence Norman</li>
        <li><strong>Company:</strong> 7HillsStudio LLC</li>
        <li><strong>Email:</strong> <a href="mailto:mchataiapp@gmail.com">mchataiapp@gmail.com</a></li>
        <li><strong>Mailing Address:</strong> 1108 13th Ave, Seattle, WA 98122, USA</li>
      </ul>

      <h2>Submitting a DMCA Notice (for copyright owners)</h2>
      <p>If you believe that content hosted on mchatai.com or distributed through our
      applications infringes a copyright that you own or are authorized to enforce, please send
      a written notification to our designated agent that includes all of the following, as
      required by 17 U.S.C. § 512(c)(3):</p>
      <ol>
        <li>A physical or electronic signature of the copyright owner or a person authorized to
        act on their behalf.</li>
        <li>Identification of the copyrighted work claimed to have been infringed (or, for
        multiple works at a single site, a representative list).</li>
        <li>Identification of the material that is claimed to be infringing, with sufficient
        detail (URLs, item names, publisher account, etc.) to allow us to locate it.</li>
        <li>Your contact information: full name, mailing address, telephone number, and email
        address.</li>
        <li>A statement that you have a good-faith belief that the use of the material in the
        manner complained of is not authorized by the copyright owner, its agent, or the law.</li>
        <li>A statement, under penalty of perjury, that the information in the notification is
        accurate and that you are the copyright owner or are authorized to act on the copyright
        owner's behalf.</li>
      </ol>
      <p>You may copy and complete the template at the bottom of this page.</p>

      <h2>What happens when we receive a valid notice</h2>
      <p>Upon receipt of a notice that substantially complies with the requirements above, we
      will:</p>
      <ul>
        <li>Remove or disable access to the allegedly infringing material, typically within one
        to three business days.</li>
        <li>Notify the user who posted the material, including a copy of the notice (with your
        contact information).</li>
        <li>Inform the user of their right to submit a counter-notice under § 512(g).</li>
      </ul>
      <p>If a notice does not substantially comply with the statutory requirements, we may
      contact you for clarification before acting.</p>

      <h2>Submitting a Counter-Notice (for users whose content was removed)</h2>
      <p>If you believe your content was removed or disabled in error or as a result of
      misidentification, you may submit a written counter-notification to our designated agent.
      Your counter-notice must include all of the following, as required by 17 U.S.C. § 512(g)(3):</p>
      <ol>
        <li>Your physical or electronic signature.</li>
        <li>Identification of the material that was removed and the location at which it
        appeared before removal.</li>
        <li>A statement under penalty of perjury that you have a good-faith belief that the
        material was removed or disabled as a result of mistake or misidentification.</li>
        <li>Your full name, mailing address, telephone number, and a statement that you consent
        to the jurisdiction of the U.S. Federal District Court for the district in which your
        address is located (or, if outside the United States, for any judicial district in which
        we may be found), and that you will accept service of process from the person who
        provided the original DMCA notice.</li>
      </ol>
      <p>If we receive a valid counter-notice, we will forward it to the original complaining
      party. Unless that party files a court action seeking a restraining order against you
      within ten to fourteen business days, we may restore the removed material.</p>

      <h2>Repeat-Infringer Policy</h2>
      <p>We terminate, in appropriate circumstances, the accounts of users who are repeat
      copyright infringers. We assess this on a case-by-case basis, taking into account the
      number and severity of validated DMCA notices, the user's response to those notices, and
      whether the infringement appears willful. Account termination may include disabling sign-in,
      removing all published content, and prohibiting account re-registration.</p>

      <h2>False Claims</h2>
      <p>Under 17 U.S.C. § 512(f), any person who knowingly materially misrepresents that
      content is infringing, or that content was removed by mistake, may be liable for damages,
      including costs and attorneys' fees. Please file DMCA notices and counter-notices only
      when you have a good-faith belief that they are accurate.</p>

      <h2>Notice template</h2>
      <p>You may use the following template when submitting a DMCA notice:</p>
      <pre style={{ whiteSpace: 'pre-wrap', padding: '12px', background: '#f5f5f5', borderRadius: '6px' }}>{`To: Lawrence Norman, Designated Agent
7HillsStudio LLC
mchataiapp@gmail.com

Subject: DMCA Takedown Notice

1. Copyrighted work allegedly infringed:
   [Describe the work, including registration number if available]

2. Material claimed to be infringing (please include URL or item ID):
   [https://mchatai.com/hub/... or specific item name]

3. My contact information:
   Name:
   Mailing address:
   Phone:
   Email:

4. I have a good-faith belief that the use of the material described above is not
   authorized by the copyright owner, its agent, or the law.

5. The information in this notification is accurate and, under penalty of perjury, I am
   the copyright owner or am authorized to act on behalf of the owner of an exclusive
   right that is allegedly infringed.

Signature: ____________________
Date: ____________________`}</pre>

      <p style={{ marginTop: '24px', fontSize: '0.85em', color: '#666' }}>
        This page provides general information about the DMCA process at mChatAI and is not
        legal advice. If you have questions about your rights, consult a qualified attorney.
      </p>
    </div>
  );
};

export default DMCAPage;
